import React, {Component} from 'react';
import {subscriptionType} from "../subscriptionType";

class CompanySubscriptionSelect extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let selectedSubscriptionType = this.props.sortableList.subscriptionType || null;

        return (
            <div className="form-group">
                <select className="form-control" onChange={s => this.props.onSubscriptionSelect(s.target.value)}
                        defaultValue={selectedSubscriptionType}>
                    <option value="">Alle abonnementstyper</option>
                    {
                        subscriptionType.map(
                            subscriptionType =>
                            <option key={subscriptionType.value} value={subscriptionType.value}>{subscriptionType.title}</option>
                        )
                    }
                </select>
            </div>
        );
    }
}

export default CompanySubscriptionSelect;


// WEBPACK FOOTER //
// ./web/src/components/company/list/CompanySubscriptionSelect.jsx